import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Sponsored from "./Sponsored";
import Card from "./Card";
import Button from "./Button";

import BgBlueCircleImage from "../../../assets/images/service-card-bg.png";
import DDxImage from "../../../assets/images/ddx-home.png";
import { getHistoryCount } from "../service";
import HistoryDrawer from "../../generateDDx/components/HistoryDrawer";
import useStore from "../../../store/useStore";
import { shouldShowSponsorship } from "../../../utils/appConfig";
import {
  markFeatureEntry,
  trackZymedEvent,
  ZYMED_EVENTS,
  ZYMED_SOURCE,
} from "../../../utils/zymedAnalytics";

const DifferentialDiagnosisCard: FC = () => {
  const navigate = useNavigate();
  const [isHistoryDrawerOpen, setIsHistoryDrawerOpen] =
    useState<boolean>(false);
  const { ddxHistoryCount, setDDxHistoryCount, planDetails } = useStore();

  const getHistoryDetails = async () => {
    const res = await getHistoryCount();
    if (res?.status === 200) {
      setDDxHistoryCount(res?.data?.length);
    }
  };

  const onPressHistoryItem = (historyId: string, pastCaseDate?: string) => {
    trackZymedEvent(ZYMED_EVENTS.DDX_HISTORY_ITEM_CLICKED, {
      case_id: historyId,
      past_case_date: pastCaseDate,
    });
    window.location.replace(`/generate-ddx?historyId=${historyId}`);
  };

  useEffect(() => {
    getHistoryDetails();
  }, []);

  return (
    <div className="p-4">
      <Card className=" relative bg-white !p-0">
        {shouldShowSponsorship() && (
          <div className="absolute left-0 top-0 ">
            <Sponsored />
          </div>
        )}
        <section>
          <div className="flex items-center">
            <div className="p-6 pr-0 font-poppins text-left w-[60%]">
              <div className=" font-semibold text-2xl text-[#1F2933]">
                Differential Diagnosis
              </div>
              <div className=" text-[#3D4854] text-sm mt-2">
                AI tool helps generate possible diagnosis by analyzing patient
                data.
              </div>
              <div
                className=" text-[#4B4AD5] text-sm font-semibold underline mt-1 cursor-pointer hover:text-[#3B3AC5] transition-colors"
                onClick={() => {
                  markFeatureEntry("/about-ddx", ZYMED_SOURCE.HOME_CARD_CTA);
                  navigate("/about-ddx");
                }}
              >
                Know more
              </div>
            </div>

            <img
              src={BgBlueCircleImage}
              className="absolute top-0 right-0 max-w-[65%] pointer-events-none"
              alt="icon"
            />
            <img
              src={DDxImage}
              className="h-[130px] z-10 -translate-y-5 pointer-events-none"
              alt="icon"
            />
          </div>
          <div className="p-4 !pt-0">
            {(ddxHistoryCount ?? 0) > 0 && (
              <Button
                className="!mt-0 bg-white !text-[#4B4AD5] border !border-[#4B4AD5] z-20 relative"
                label="View History"
                onClick={() => {
                  trackZymedEvent(ZYMED_EVENTS.DDX_HISTORY_OPENED, {
                    source: "home_view_history",
                  });
                  setIsHistoryDrawerOpen(true);
                }}
              ></Button>
            )}
            <Button
              className={`z-20 relative ${
                !((ddxHistoryCount ?? 0) > 0) ? "!mt-0" : ""
              }`}
              label="Generate DDx"
              onClick={() => {
                markFeatureEntry("/generate-ddx", ZYMED_SOURCE.HOME_CARD_CTA);
                if (planDetails?.metadata?.ddx) navigate("/generate-ddx");
                else navigate("/ddx-welcome");
              }}
            ></Button>
          </div>
        </section>
      </Card>
      <HistoryDrawer
        open={isHistoryDrawerOpen}
        onClose={() => setIsHistoryDrawerOpen(false)}
        onPressHistoryItem={onPressHistoryItem}
      />
    </div>
  );
};

export default DifferentialDiagnosisCard;
